module.exports = __webpack_public_path__ + "img/Levanta_Junteo Grueso R125.fd611421.png";